import { TelegramIcon } from "@/components/icons";
import { m } from "@/paraglide/messages";

export default function PaymentNotice() {
	return (
		<div className="text-sm text-t2 leading-normal font-medium flex justify-center">
			<div className="inline-block">
				<div className="">
					* {m.payment_notice_2()}
					<a
						href="https://t.me/peach_lust"
						className="text-c7 ml-1 inline-flex items-center h-4 relative top-0.75"
					>
						<TelegramIcon className="[&>path]:fill-c7 w-[15px] min-w-[15px] h-auto relative -top-[1px] mr-0.5" />
						{m.payment_notice_3()}
					</a>
				</div>
			</div>
		</div>
	);
}
